import React from 'react';
import '../../popups/Popup/BasePopup/index.js';
import '../../popups/Popup/Thumb/index.js';
import '../../popups/Popup/ThumbV2/index.js';
import { InfoTooltip } from '../../popups/Popup/InfoTooltip/index.js';
import '../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import 'classnames';
import '../../../common/GradientWrapper/index.js';
import '../../../common/Icon/index.js';
import '../../../common/LazyImage/index.js';
import { NumberFormat } from '../../../common/NumberFormat/index.js';
import '../../../common/WithCustomScrollbar/index.js';
import styles from './index.module.scss.js';

const AmountValue = ({
  amount,
  hasSignPrefix = true,
  integerSeparator = " ",
  cryptoCurrency,
  cryptoCurrencyIcon,
  color = "",
  currency,
  tooltipData,
  popupStyle
}) => tooltipData ? /* @__PURE__ */ React.createElement(
  InfoTooltip,
  {
    withIcon: false,
    white: true,
    maxWidth: 150,
    popupStyle: {
      minWidth: 150,
      ...popupStyle
    },
    showEvent: "hover",
    anchor: /* @__PURE__ */ React.createElement(
      "div",
      {
        className: styles.box,
        style: {
          "--color": color
        }
      },
      /* @__PURE__ */ React.createElement(
        "img",
        {
          src: cryptoCurrencyIcon || `/crypto/${cryptoCurrency}.png`,
          alt: cryptoCurrency
        }
      ),
      /* @__PURE__ */ React.createElement(
        NumberFormat,
        {
          hasSignPrefix,
          value: amount,
          prefix: currency,
          padRight: 2,
          integerSeparator
        }
      )
    ),
    style: {
      textWrap: "nowrap"
    }
  },
  /* @__PURE__ */ React.createElement(
    "div",
    {
      style: {
        textAlign: "center"
      }
    },
    tooltipData
  )
) : /* @__PURE__ */ React.createElement(
  "div",
  {
    className: styles.box,
    style: {
      "--color": color
    }
  },
  /* @__PURE__ */ React.createElement(
    "img",
    {
      src: cryptoCurrencyIcon || `/crypto/${cryptoCurrency}.png`,
      alt: cryptoCurrency
    }
  ),
  /* @__PURE__ */ React.createElement(
    NumberFormat,
    {
      hasSignPrefix,
      value: amount,
      prefix: currency,
      padRight: 2,
      integerSeparator
    }
  )
);
AmountValue.displayName = "AmountValue";

export { AmountValue };
//# sourceMappingURL=index.js.map
